import React, {Component} from 'react'
import Blog from './Blog'

const Jeyu = {
  Box: {
    height: '100vh',
    background: '#fff'
  },
  InfoBox: {
    background:'#9e3030',
    padding: '40px 10px'
  },
}

export default class KnowledgeBase extends Component {
  componentDidMount () {
   window.scrollTo(0, 0)
  }
  componentWillUnmount() {
   window.scrollTo(0, 0)
  }
  render(){
    return(
      <div style={Jeyu.Box}>
      <div style={Jeyu.InfoBox}></div>
       <Blog />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/View/Blog/KnowledgeBase.js